export default __webpack_public_path__ + "static/media/pinterest.d47d36ab.svg";